import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const Loading = () => {
  const { t } = useTranslation(undefined, { useSuspense: false });
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setSlow(true), 10000);
    return () => window.clearTimeout(timer);
  }, []);
  const containerRef = useRef<HTMLDivElement>(null);
  const [offsetTop, setOffsetTop] = useState(0);

  useEffect(() => {
    const calculateOffset = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setOffsetTop(rect.top);
      }
    };

    calculateOffset();

    window.addEventListener("resize", calculateOffset);

    return () => {
      window.removeEventListener("resize", calculateOffset);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex w-full flex-col gap-4 items-center justify-center transition-[height]"
      style={{ height: `calc(100vh - ${offsetTop}px)` }}
    >
      <img
        src="/images/care_logo_gray.svg"
        className="App-logo"
        alt={t("phase2_loading.loading")}
      />
      {slow && (
        <div
          role="status"
          className="max-w-md px-4 text-center text-sm text-slate-600"
        >
          <p>{t("phase2_loading.slow")}</p>
          <button
            type="button"
            className="mt-3 underline"
            onClick={() => {
              if (window.confirm(t("phase2_loading.confirm_reload")))
                window.location.reload();
            }}
          >
            {t("phase2_loading.reload")}
          </button>
        </div>
      )}
    </div>
  );
};

export default Loading;
